export const MQTT_CA_CERT_FILE = "src/certs/emqxsl-ca.crt";

export type MQTTConfig = {
  enabled: boolean;
  brokerAddress: string;
  brokerPort: number;
  wsPort: number;
  username: string;
  password: string;
  topicPrefix: string;
  qos: 0 | 1 | 2;
  brokerUrl?: string;
};

export const DEFAULT_MQTT_CONFIG: MQTTConfig = {
  enabled: true,
  brokerAddress: "vecbae77.ala.us-east-1.emqxsl.com",
  brokerPort: 8883,
  wsPort: 8084,
  username: "for-sonifi",
  password: "sonifi-mqtt",
  topicPrefix: "adstorm/players",
  qos: 1,
};

export const mqttConfig: MQTTConfig = { ...DEFAULT_MQTT_CONFIG };

export function applyMQTTConfig(overrides: Partial<MQTTConfig>): void {
  Object.assign(mqttConfig, overrides);
}

export function isMQTTEnabled(): boolean {
  return mqttConfig.enabled;
}

export function buildMQTTBrokerUrl(): string {
  if (mqttConfig.brokerUrl) return mqttConfig.brokerUrl;
  return `wss://${mqttConfig.brokerAddress}:${mqttConfig.wsPort}/mqtt`;
}

export function buildPlayerTopic(
  licenseKey: string,
  channel: "metrics" | "impressions" | "heartbeat"
): string {
  return `${mqttConfig.topicPrefix}/${licenseKey}/${channel}`;
}
